var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_vm._t("default",function(){return [_c('img',{style:({ height: '100%' }),attrs:{"title":"MesBonsPros","alt":"MesBonsPros","src":require("../assets/logo.svg")}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }